// extracted by mini-css-extract-plugin
module.exports = {"fontLato":"Lato, Menlo, Monaco, Consolas, \"Courier New\", monospace","logoIcon":"styles_logoIcon__1U6XM"};